import React, { useEffect } from 'react';
import styles from './SecondScreen.module.css';
import ScrollReveal from 'scrollreveal';
import SmallBox from '../SecondReceptionistComponents/smallBox/smallbox';
import problemSolvingIcon from '../icons/wired-outline-36-bulb-hover-blink.json';
import peopleIcon from '../icons/wired-outline-3138-customer-insights-alt-hover-pinch.json';
import moneyIcon from '../icons/wired-outline-414-money-bag-dollar-hover-shake.json';
import organizationIcon from '../icons/wired-outline-1007-organization-hover-pinch.json';

const SecondScreenRec = () => {
  const cards = [
    {
      icon: problemSolvingIcon,
      text: 'את טובה בלפתור בעיות ודברים שאנשים לא רוצים להתעסק בהם'
    },
    {
      icon: peopleIcon,
      text: 'כולם תמיד פונים אלייך עם בעיות כי "את יודעת לתקתק אותן הכי טוב"'
    },
    {
      icon: moneyIcon,
      text: 'הבנת שכל ה\'טובות\' שאת עושה לאחרים בחינם - שוות הרבה כסף.'
    },
    {
      icon: organizationIcon,
      text: 'איפה שאחרים רואים "בלאגן", את כבר רואה בראש את הפתרון.'
    }
  ];

  useEffect(() => {
    // ScrollReveal animations
    ScrollReveal().reveal(`.${styles.title}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
    });
  }, []);

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>
        אם הגעת לכאן סימן ש...
      </h2>
      
      <div className={styles.cardsGrid}>
        {cards.map((card, index) => (
          <SmallBox
            key={index}
            icon={card.icon}
            text={card.text}
          />
        ))}
      </div>
    </section>
  );
};

export default SecondScreenRec;
